<template>
  <div>
    <Spinner ref="spinner" :block="true"/>
    <div class="form-group">
      <button class="btn btn-outline-secondary btn-sm">
        Cancelar transações selecionadas
      </button>
      <button class="btn btn-outline-danger btn-sm pull-right" @click="reportFraud()" :disabled="reportedAsFraud">
        <a v-if="!reportedAsFraud">Sinalizar Fraude</a>
        <a v-else>Fraude sinalizada</a>
      </button>
    </div>
    <div class="table-responsive">
      <table class="table mb-0">
        <thead>
          <tr class="d-flex">
            <th class="col-1 text-center">
              <label class="checkbox checkbox-success">
                <input type="checkbox" @click="selectAll" v-model="allSelected" />
                <span class="check-mark"></span>
              </label>
            </th>
            <th class="col">NSU <small>(Paggcerto)</small></th>
            <th class="col">NSU <small>(Adquirente)</small></th>
            <th class="col">Número do cartão</th>
            <th class="col">Valor</th>
            <th class="col">Situação</th>
          </tr>
        </thead>
        <tbody>
          <tr class="d-flex" v-for="cardTransactionOccurrence in cardTransactionOccurrences" :key="cardTransactionOccurrence.id">
            <td class="col-1 text-center">
              <label class="checkbox checkbox-success">
                <input type="checkbox"  @click="select(cardTransactionOccurrence)" v-model="cardTransactionOccurrence.checked"/>
                <span class="check-mark"></span>
              </label>
            </td>
            <td class="col">
              <a href="#">{{cardTransactionOccurrence.cardTransaction.nsu }}</a><br>
              <small class="text-secondary">{{ cardTransactionOccurrence.cardTransaction.paidAt | date }}</small>
            </td>
            <td class="col force-break-word">
              <span v-if="cardTransactionOccurrence.cardTransaction.acquirerNsu">
                {{ cardTransactionOccurrence.cardTransaction.acquirerNsu }}
              </span>
              <span v-else>
                ------
              </span>
              <br>
              <small class="text-secondary">{{ cardTransactionOccurrence.cardTransaction.acquirer }}</small>
            </td>
            <td class="col">
              {{ cardTransactionOccurrence.cardTransaction.cardNumber }}<br>
              <small class="text-secondary">{{ cardTransactionOccurrence.cardTransaction.cardBrand }}</small>
            </td>
            <td class="col">
              {{ cardTransactionOccurrence.cardTransaction.amountPaid | currency("R$ ", 2, { decimalSeparator: ',' , thousandsSeparator: '.' }) }}<br>
              <small class="text-secondary">{{ cardTransactionOccurrence.cardTransaction.installments + 'x de ' }} {{cardTransactionOccurrence.cardTransaction.installmentValue | currency("R$ ", 2, { decimalSeparator: ',' , thousandsSeparator: '.' }) }}</small>
            </td>
            <td class="col">
              <span v-if="isApproved(cardTransactionOccurrence.cardTransaction)">
                <i class="fa fa-circle font-sm text-success"></i> Aprovada
              </span>
              <span  v-if="isReproved(cardTransactionOccurrence.cardTransaction)">
                <i class="fa fa-circle font-sm text-danger"></i> Reprovada
              </span>
              <span  v-if="isCanceled(cardTransactionOccurrence.cardTransaction)">
                <i class="fa fa-circle font-sm text-warning"></i> Cancelada
              </span>
              <span  v-if="isContested(cardTransactionOccurrence.cardTransaction)">
                <i class="fa fa-circle font-sm text-dark"></i> Contestada
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <paginator :count="countTransactions" :perPage="perPage" @exchange="turnPage" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuspiciousActivityTransactions',
  data () {
    return {
      filter: {
        index: 0,
        length: 10
      },
      cardTransactionOccurrences: [],
      perPage: 10,
      count: 0,
      allSelected: false,
      reportedAsFraud: false
    }
  },
  async mounted () {
    await this.search()
  },
  props: {
    occurrence: Object
  },
  methods: {
    async search (suspiciousType) {
      if (!suspiciousType) return

      this.$refs.spinner.show('Pesquisando transações...')

      this.filter.suspiciousType = suspiciousType
      const result = await this.$api.cardTransactionOccurrences.list(this.occurrence.id, this.filter)
      this.count = result.count
      this.cardTransactionOccurrences = result.cardTransactionOccurrences

      this.reportedAsFraud = true

      for (let c of this.cardTransactionOccurrences) {
        this.reportedAsFraud = this.reportedAsFraud && (c.isFraud === true)
      }

      this.$refs.spinner.hide()
    },
    async turnPage (numberPage) {
      this.allSelected = false
      const fim = numberPage * this.perPage
      const inicio = fim - this.perPage
      this.filter.index = inicio
      this.filter.length = this.perPage
      await this.search(this.filter.suspiciousType)
    },
    select (cardTransactionOccurrence) {
      cardTransactionOccurrence.checked = !cardTransactionOccurrence.checked
    },
    selectAll () {
      this.allSelected = !this.allSelected
      let checked = this.allSelected
      this.cardTransactionOccurrences.forEach(function (value, key) {
        if (checked) {
          value.checked = true
        } else {
          value.checked = false
        }
      })
    },
    async reportFraud () {
      const { value: note } = await this.showReportNoteRecorder()

      if (this.cardTransactionOccurrences.length <= 0 || note === undefined) return

      this.$refs.spinner.show('Reportando fraude.')

      const result = await this.$api.cardTransactionOccurrences.reportFraud(
        this.cardTransactionOccurrences,
        note)

      this.$refs.spinner.hide()

      if (!result) {
        await this.$swal('Falha no processamento')
      }

      await this.search(this.filter.suspiciousType)
    },
    async showReportNoteRecorder () {
      return this.$swal({
        title: 'Parecer',
        input: 'textarea',
        inputPlaceholder: 'Escreva aqui suas conclusões.',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        inputValidator (value) {
          if (value.length >= 3 && value.length <= 255) return

          return 'O parecer deve conter entre 3 e 255 caracteres.'
        }
      })
    },
    isApproved (cardTransaction) {
      return cardTransaction.approvedAt &&
        !this.isReproved(cardTransaction) &&
        !this.isCanceled(cardTransaction) &&
        !this.isContested(cardTransaction)
    },
    isReproved (cardTransaction) {
      return !!cardTransaction.reprovedAt
    },
    isCanceled (cardTransaction) {
      return !!cardTransaction.canceledAt &&
        !this.isContested(cardTransaction)
    },
    isContested (cardTransaction) {
      return !!cardTransaction.contestedOn
    }
  },
  computed: {
    countTransactions () {
      return this.count
    }
  }
}
</script>

<style scoped>
.force-break-word {
  word-break: break-word;
}
</style>
